import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

import { TranslationService } from '../../../../i18n/translation.service';
import { AuditDto } from './../../../../core/api/models/audit-dto';

@Component({
    selector: 'app-audit-detail',
    templateUrl: './audit-detail.component.html',
    styles: [
        `
      .comments-text {
        height: 176px !important;
      }
    `,
    ],
    standalone: false
})
export class AuditDetailComponent implements OnInit {
  //#region Properties

  title = 'pages.audits.auditDetail';
  fields = 'pages.audits.fields.';

  loading: boolean = false;
  protected onDestroy$ = new Subject<void>();

  @Input() model: AuditDto;
  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  //#endregion

  constructor(public translationService: TranslationService) {}

  ngOnInit() {
    window.scroll(0, 0);
  }

  onClose() {
    this.output_closPage.emit(true);
  }
}
